import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { OrderHistory } from '../../../../generic/classes/order.history';
import { Logger } from '../../../../generic/logging/default-log.service';
import { ApplicationService } from '../../../../generic/service/application.service';
import { OrderHistoryService } from '../../../../service/order.history.service';
import { NumberFormatPipe } from '../../../../generic/pipes/number.format.pipe';
import { CustomDatePipe } from '../../../../generic/pipes/custom.date.pipe';
import { RenderHistoryStatusComponent } from './render.history.status';
import { SalespersonTelephoneComponent } from '../../../../generic/component/my/salesperson.telephone.component';

@Component({
    selector: 'order-history',
    templateUrl: 'history.component.html',
    standalone: true,
    imports: [
        RouterLink,
        SalespersonTelephoneComponent,
        RenderHistoryStatusComponent,
        CustomDatePipe,
        NumberFormatPipe,
    ],
})
export class OrderHistoryComponent {
    orders: Array<OrderHistory>;
    noOrders: boolean = false;

    constructor(
        private orderService: OrderHistoryService,
        private applicationService: ApplicationService,
        private router: Router,
        private logger: Logger,
    ) {
        this.orderService.getOrderHistory().subscribe(
            orders => this.setOrderHistory(orders),
            error => this.logger.error('Failed to get order history', error),
        );
    }

    /**
     * Opens the popup for a new order and listens for a successful close to redirect.
     *
     */
    startNewOrder() {
        this.applicationService.openPopup(() => {
            this.router.navigate(['/products']);
            this.applicationService.closePopup();
        });
    }

    private setOrderHistory(orders) {
        this.orders = orders;
        this.noOrders = orders.length === 0;
    }
}
